import { CarouselData } from "./types";
import routes from "@/constants/routes";

const carouselData: CarouselData = [
  {
    header: "Step 1",
    link: {
      caption: "Step 1",
      href: routes.howitworks + "#step1",
    },
  },
  {
    header: "Step 2",
    link: {
      caption: "Step 2",
      href: routes.howitworks + "#step2",
    },
  },
  {
    header: "Step 3",
    link: {
      caption: "Step 3",
      href: routes.howitworks + "#step3",
    },
  },
  {
    header: "Step 4",
    link: {
      caption: "Step 4",
      href: routes.howitworks + "#step4",
    },
  },
  {
    header: "Step 5",
    link: {
      caption: "Step 5",
      href: routes.howitworks + "#step5",
    },
  },
];

export const generateCarouselData = () => {
  return carouselData;
};
